// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__D1ofd"};